import React from "react";
import UserModal from "../../components/EmailModal/UserModal";
import TermsPos from "../Terms/TermsPos";
import { PropTypes } from "prop-types";

export const TermsModal = ({ showModal, hideModal }) => {
  return (
    <UserModal open={showModal} close={hideModal} height={"700"} width={"1000"}>
      <div style={{ padding: "20px" }}>
        <span
          className="iframe-back2"
          data-testid="hideModal"
          onClick={() => hideModal()}
        >
          X
        </span>
        <div className="modal-header3">
          <h1>TERMS AND CONDITIONS – STATEMENT OF COMPLIANCE</h1>
        </div>
        <TermsPos />
      </div>
    </UserModal>
  );
};

TermsModal.propTypes = {
  showModal: PropTypes.bool,
  hideModal: PropTypes.func
}

export default TermsModal;
